import get from 'lodash/get'

const state = {
  customerConfig: null,
  customerAssetViewConfig: null,
  mapboxglApiKey: null,
}

const getters = {
  customerConfig: (state) => state.customerConfig,
  mapboxglApiKey: (state) => get(state, 'mapboxglApiKey', null),
  emails: (state) => get(state, 'customerConfig._source.reports.emails', []),
  externalDashboards: (state) =>
    get(state, 'customerConfig._source.externalDashboards', []),
  quickConnectSlave: (state) =>
    get(state, 'customerConfig._source.quickConnectSlave', false),
  assetViewConfig: (state) =>
    get(state, 'customerConfig._source.assetView', null),
  assetListConfig: (state) =>
    get(state, 'customerConfig._source.assetList', null),
  timezone: (state) =>
    get(state, 'customerConfig._source.timezone', 'Europe/Paris'),
  customFieldsName: (state) =>
    get(state, 'customerConfig._source.customFieldsName', []),
  customerAssetViewConfig: (state) =>
    get(state, 'customerAssetViewConfig._source', {}),
}

const actions = {
  FETCH_CURRENT_CUSTOMER_CONFIG: async ({ commit, rootGetters }, kuzzle) => {
    if (!rootGetters['auth/currentIndex']) {
      return
    }
    const customerIndex = rootGetters['auth/currentIndex']

    try {
      const response = await kuzzle.query({
        controller: 'omniscient/customer',
        action: 'getConfig',
        body: {
          customerIndex,
        },
      })
      if (response.result) {
        commit('SET_MAPBOX_API_KEY', response.result.mapboxglApiKey)
        commit('SET_CURRENT_CUSTOMER_CONFIG', response.result.customerConfig)
        commit(
          'SET_CURRENT_CUSTOMER_LAYOUT_CONFIG',
          response.result.viewCustomLayoutConfig,
        )
      }
    } catch (error) {
      throw error
    }
  },
}

const mutations = {
  SET_CURRENT_CUSTOMER_CONFIG: (state, config) => {
    state.customerConfig = config
  },
  SET_MAPBOX_API_KEY: (state, mapboxglApiKey) => {
    state.mapboxglApiKey = mapboxglApiKey
  },
  SET_CURRENT_CUSTOMER_LAYOUT_CONFIG: (state, config) => {
    state.customerAssetViewConfig = config
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
